import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-lg" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "modal-title" }
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "form-group" }

import { computed, ref, toRef } from 'vue'
    import type { PropType } from 'vue'
    import type { CriteriaFromStringBuilderViewModel } from "@Criteria/Hierarchies/Components/CriteriaFromStringBuilder"

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CriteriaFromStringBuilder',
  props: {
        viewModel: {
            type: Object as PropType<CriteriaFromStringBuilderViewModel>,
            required: true
        }
    },
  emits: ["create-criteria"],
  setup(__props, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- state ----------------

    const vm = toRef(props, 'viewModel')

    const criteriaString = ref<string | null>(null)

    // ---------------- computed ----------------

    const opened = computed(() => vm.value.isOpen)
    const parentName = computed(() => vm.value.parentName)

    // ---------------- actions ----------------

    function handleFormSubmit()
    {
        emit('create-criteria', vm.value.parentId!, criteriaString.value)
        criteriaString.value = null
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h5", _hoisted_6, "Add criteria under: " + _toDisplayString(parentName.value), 1 /* TEXT */),
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: close
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("form", {
                  id: "criteria-from-string-builder-form",
                  onSubmit: _withModifiers(handleFormSubmit, ["prevent"])
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[1] || (_cache[1] = _createElementVNode("label", null, "Enter criteria below, each on a new line:", -1 /* CACHED */)),
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((criteriaString).value = $event)),
                      class: "form-control",
                      rows: "8",
                      required: ""
                    }, null, 512 /* NEED_PATCH */), [
                      [
                        _vModelText,
                        criteriaString.value,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ])
                ], 32 /* NEED_HYDRATION */)
              ]),
              _createElementVNode("div", { class: "modal-footer" }, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: close,
                  class: "btn btn-outline-secondary"
                }, "Close"),
                _cache[2] || (_cache[2] = _createElementVNode("button", {
                  type: "submit",
                  form: "criteria-from-string-builder-form",
                  class: "btn btn-primary"
                }, "Create", -1 /* CACHED */))
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})